/**
 * Returns the event date in milliseconds if it should be used for countdown UI,
 * or undefined if countdowns are hidden, the date is missing, or the event is in the past.
 */
export const getEventDate = (hideEventCountdown: boolean | undefined, finalizedDateMs: number | undefined | null): number | undefined => {
  if (hideEventCountdown || finalizedDateMs == null) {
    return undefined;
  }
  return finalizedDateMs > Date.now() ? finalizedDateMs : undefined;
};
